/**
 * @generated SignedSource<<c1bd5d796ce29fd302a58074897b58ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_viewer$data = {
  readonly pdpHolidayShippingFeatureFlag: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingHolidayDelivery_viewer">;
  readonly " $fragmentType": "PdpRespSidebarBlurbShipping_viewer";
};
export type PdpRespSidebarBlurbShipping_viewer$key = {
  readonly " $data"?: PdpRespSidebarBlurbShipping_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_viewer",
  "selections": [
    {
      "alias": "pdpHolidayShippingFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "HOLIDAY_SHIPPING"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"HOLIDAY_SHIPPING\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "210b1c287cb8ba9784365c84457a02d4";

export default node;
